"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpritesheetsUtils = void 0;
var SpritesheetsUtils;
(function (SpritesheetsUtils) {
    SpritesheetsUtils.characterSpriteStateList = ['idle', 'walk', 'attack', 'hit'];
    SpritesheetsUtils.getSpellTextureKey = function (spellRole) { return "spells/" + spellRole + ".png"; };
    SpritesheetsUtils.getCharacterAnimationPath = function (_a) {
        var role = _a.role, state = _a.state, orientation = _a.orientation;
        return "characters/" + role + "/" + state + "/" + orientation + "/" + role + "_" + state + "_" + orientation;
    };
    var defaultFrameDuration = [400];
    var defaultFramesDurations = {
        idle: {
            bottom: [640, 80, 640],
            default: [940, 820]
        },
        walk: { default: [100] },
        attack: {
            default: [300, 100, 100, 200]
        },
        hit: {
            default: [360, 80, 80, 80, 50, 50]
        }
    };
    var framesDurationsMap = {
        tacka: defaultFramesDurations,
        meti: defaultFramesDurations,
        vemo: defaultFramesDurations
    };
    SpritesheetsUtils.getCharacterFramesDurations = function (_a) {
        var _b, _c;
        var role = _a.role, state = _a.state, orientation = _a.orientation;
        var lvRole = framesDurationsMap[role];
        var lvState = lvRole[state];
        return (_c = (_b = lvState[orientation]) !== null && _b !== void 0 ? _b : lvState.default) !== null && _c !== void 0 ? _c : defaultFrameDuration;
    };
    SpritesheetsUtils.getCharacterFramesOrder = function (_a) {
        var state = _a.state;
        if (state === 'hit') {
            return [1, 2, 3, 2, 3, 4];
        }
    };
    SpritesheetsUtils.getCharacterFlipInfos = function (config) {
        return config.orientation === 'left'
            ? {
                direction: 'horizontal',
                flipConfig: __assign(__assign({}, config), { orientation: 'right' })
            }
            : null;
    };
})(SpritesheetsUtils = exports.SpritesheetsUtils || (exports.SpritesheetsUtils = {}));
